import { BadgeCheck, MapPin } from "lucide-react";
import Reveal from "@/components/base/Reveal";
import Icon from "@/components/base/Icon";
import { company, values } from "@/mocks/home";

export default function About() {
  return (
    <section id="sobre" className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-container px-4 md:px-6 lg:px-10">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal className="order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              Sobre Nós
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              Pessoas que cuidam do seu condomínio como se fosse o deles.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700 md:text-lg">
              A {company.name} nasceu da vontade de tornar a vida em condomínio mais simples e tranquila. Acreditamos que
              uma boa gestão se constrói com transparência, organização e uma comunicação clara com todos os condóminos.
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Somos uma empresa local, sediada em <strong className="font-semibold text-foreground-900">{company.location}</strong>,
              o que nos permite estar verdadeiramente próximos. Conhecemos os edifícios, as pessoas e as necessidades
              reais de cada condomínio que gerimos.
            </p>

            <div className="mt-8 flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4">
              <div className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-secondary-900">
                <BadgeCheck className="h-6 w-6 text-primary-300" />
              </div>
              <div>
                <p className="font-heading text-sm font-bold text-foreground-950">{company.owner}</p>
                <p className="text-xs text-foreground-600">{company.ownerRole} · «Serviço de excelência, com rosto humano.»</p>
              </div>
            </div>
          </Reveal>

          <Reveal className="order-1 lg:order-2" delay={120}>
            <div className="relative">
              <div className="absolute -right-3 -top-3 hidden h-32 w-32 rounded-lg border-2 border-accent-400/40 lg:block" aria-hidden="true" />
              <div className="relative h-[420px] w-full overflow-hidden rounded-lg md:h-[520px]">
                <img
                  src={company.ownerPhoto}
                  alt={`${company.owner}, ${company.ownerRole} da Porta31 Condomínios`}
                  title="Marta Faustino · Administradora da Porta31 Condomínios"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3 rounded-lg border border-background-50/20 bg-secondary-950/85 px-4 py-3 backdrop-blur-md">
                <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-primary-500/20">
                  <MapPin className="h-5 w-5 text-primary-300" />
                </div>
                <div>
                  <p className="font-heading text-sm font-semibold text-background-50">Sede em Vila Nova de Famalicão</p>
                  <p className="text-xs text-background-300">Proximidade e acompanhamento local</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-20 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((value, index) => (
            <Reveal key={value.title} delay={index * 90} className="h-full">
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-50">
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <Icon name={value.icon} className="h-6 w-6" />
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{value.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}